<template>
  <div class="index">
    <div class="wrp">
      <a-spin wrapperClassName="main-col" :spinning="uploading" tip="上传中...">
        <a-upload-dragger
          class="main-col"
          name="file"
          :multiple="true"
          accept="image/*"
          :beforeUpload="beforeUpload"
          @change="handleUpload"
        >
          <p class="ant-upload-text">点击或将图片拖入开始制作</p>
          <p class="ant-upload-hint">支持扩展名：.jpg .png .bmp</p>
          <div class="upload-way">
            <div class="upload-way-item">
              <div class="upload-way-icon">
                <img src="../assets/webUpload.png" alt />
              </div>
              <div>电脑上传</div>
            </div>
            <div class="upload-way-item" @click.stop="showWapUpload">
              <div class="upload-way-icon">
                <img src="../assets/wapUpload.png" alt />
              </div>
              <div>手机上传</div>
            </div>
          </div>
        </a-upload-dragger>
      </a-spin>
      <sideBar class="sidebar-col" title="我的照片" subTitle="照片仅保存7天" iconType="folder-open">
        <div class="flex sidebar-con">
          <login
            :isLogin="isLogin"
            :toggleLoginFn="toggleLoginFn"
            :loginModal="loginModal"
            :loginBtnFn="loginBtnFn"
            :cancel="cancel"
            type="tailoring"
          />
        </div>
      </sideBar>
    </div>
    <rule :rulePopVisible="rulePopVisible" :ok="ok" />
    <wapUpload
      @handleResult="handleResult"
      @cancel="wapUploadCancel"
      :isVisible="isWapUploadVisible"
      source_page="cutPic"
    />
  </div>
</template>

<script>
import sideBar from "@/components/sidebar.vue";
import rule from "@/components/rule.vue";
import login from "@/components/login.vue";
import wapUpload from "@/components/wapUpload.vue";
import { setCookie, getCookie } from "../utils/cookie";

export default {
  data() {
    return {
      isLogin: false,
      loginModal: false,
      rulePopVisible: false,
      uploading: false,
      isWapUploadVisible: false
    };
  },
  metaInfo() {
    return {
      title: "图片裁剪丨证件照片在线裁剪修改大小尺寸工具",
      meta: [
        {
          name: "keywords",
          content: "图片裁剪，证件照，一寸证件照尺寸，最美证件照"
        },
        {
          name: "description",
          content:
            "证件照片研究院下在线裁剪修改大小尺寸工具，一寸证件照换底色，最美证件照制作，涵盖一寸、二寸、小一寸等证件图片裁剪制作，包括全部考试报名类500多种证件照片规格，计算机等级考试，国考，会计报名照片，教师资格证报名照片尺寸修改。"
        }
      ]
    };
  },
  components: {
    sideBar,
    rule,
    login,
    wapUpload
  },
  beforeMount() {
    var _hmt = _hmt || [];
    var hm = document.getElementById("baodu-hm");
    hm.src = "https://hm.baidu.com/hm.js?3fa5c95bf12e49a82215370ff03947bd";
    let token = this.$route.query.token;
    if (token) {
      setCookie("lq-handlephoto-token", token, 1);
    }
    if (getCookie("lq-handlephoto-token")) {
      this.isLogin = true;
    }
  },
  methods: {
    loginBtnFn() {
      this.loginModal = true;
    },
    toggleLoginFn(bol) {
      this.isLogin = bol;
    },
    showWapUpload(e) {
      this.isWapUploadVisible = true;
    },
    wapUploadCancel() {
      this.isWapUploadVisible = false;
    },
    cancel() {
      this.loginModal = false;
    },
    ok() {
      this.rulePopVisible = false;
      this.$router.push("/cutEdit");
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      this.uploading = true;
      if (!isLt2M) {
        this.$message.error("图片必须小于10M!");
        return isLt2M;
      }
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = _ => {
        // 和手机上传图片数据格式保持一致，｛data:XXX｝
        this.handleResult({
          data: reader.result
        });
      };
      return isLt2M;
    },
    handleResult(result) {
      sessionStorage.setItem("url", result.data);
      this.isWapUploadVisible = false;
      this.rulePopVisible = true;
    },
    handleUpload(info) {
      this.uploading = false;
    }
  }
};
</script>

<style scoped>
.sidebar-con {
  height: calc(100% - 44px);
}
.upload-way {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}
.upload-way-item {
  margin-right: 64px;
}
.upload-way-item:last-child {
  margin-right: 0;
}
.upload-way-icon {
  width: 80px;
  height: 80px;
  line-height: 80px;
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 12px;
}
.upload-way-icon img {
  width: 41px;
}
</style>